import React, { useState, useEffect } from "react";
import {
  EditPageGroups,
  Page,
  withServerErrors,
  withResolver, PendingButton,
} from "components/common";
import {
  FormGroup,
  SaveButton,
  BackButton,
  DatePicker,
  required,
} from "components/common/Forms";
import { compose, withState, withStateHandlers } from "recompose";
import { LocalForm, Control } from "react-redux-form";
import { isUndefined, orderBy } from "lodash";
import { Trans, useTranslation } from "react-i18next";
import { Row, Col, Button } from "reactstrap";
import useModal from "../../hooks/useModal";
import { NotificationManager } from "react-notifications";
import withReload from "../../components/common/withReload";
import { useMutation } from "react-query";
import { useClient } from "../../hooks";
import PermissionTable from "./PermissionTable";


const ImpersonateButton = ({ email, ...props }) => {
  const client = useClient();
  const { mutateAsync, isLoading } = useMutation(() => client.get(`admin/impersonate`, {
    params: {
      email
    }
  }), {
    onSuccess: () => {
      window.location.href = "/";
    },
    useErrorBoundary: false
  });

  return (
    <PendingButton onClick={mutateAsync} pending={isLoading} translate={false} {...props}>
      <Trans>Impersonate</Trans>
    </PendingButton>
  )
}

export const GroupEdit = ({
  mode,
  item,
  form,
  onBack,
  setDispatch,
  onUpdate,
  onChange,
  readOnly,
  stats,
  client,
  dispatch,
  reload,
  match,
  onSubmit
}) => {


  const { Modal, setIsOpen, isOpen, ModalHeader, ModalBody, ModalFooter } =
    useModal();
  const { t } = useTranslation();

  const [permissionOptions, setPermissionOptions] = useState([]);

  const [permissions, setPermissions] = useState([]);

  function isNumericString(input) {  
    return typeof input === 'string' && !isNaN(input)
  }

  const HandlePost = (item) => {
    console.log(permissions)
    if (Object.keys(item).length) {
        item = {'name':item.name, 'permissions':permissions}

        let endpoint = isNumericString(match.params.id)? `/${match.params.id}`:''
        let method = isNumericString(match.params.id)? "put":"post"
        console.log(method)
        client[method](`/authorization/group${endpoint}`,item)
          .then(({ data }) => {
                if (method === "post") {
                    NotificationManager.success(t('Group created successfully'));
                } else {
                    NotificationManager.success(t('Group updated successfully'));
                }
            return true
          })
          .catch((err) => {
            NotificationManager.error(t('Error at updating/creating group'));
            return false
          });
    }else{
        NotificationManager.error(t('Please verify your information'));
    }

  }
  useEffect(() => {
    client.get("/authorization/permission")
      .then((response) => {
        setPermissionOptions(response.data);
      })
      .catch((error) => {
        console.error("Error fetching permission options:", error);
      });
  }, []);

  useEffect(() => {
      setPermissions(item? item.permissions:[])
  }, []);

    return (
      <Page title={`${mode} Add Permissions Group`}>
        <LocalForm
          initialState={item}
          onSubmit={onSubmit}
          getDispatch={setDispatch}
          onUpdate={onUpdate}
          onChange={onChange}
        >
          {isOpen ? (
            <Modal>
              <ModalHeader>
                <Trans>Activate Group</Trans>
              </ModalHeader>
              <ModalBody>
                <Trans>
                  Are you sure you want to activate this group? This will end
                  the permissions for this group.
                </Trans>
              </ModalBody>
              <ModalFooter>
                <Row form>
                  <Col xs="auto">
                    <Button color="link" onClick={() => setIsOpen(false)}>
                      Close
                    </Button>
                  </Col>
                  <Col xs="auto">
                    <SaveButton form={form} onClick="">
                      Confirm
                    </SaveButton>
                  </Col>
                </Row>
              </ModalFooter>
            </Modal>
          ) : null}
          <FormGroup label="Group Name*" model=".name">
            <Control.text model=".name" required disabled={readOnly} />
          </FormGroup>
          <FormGroup label="Description" model=".description">
            <Control.text model=".Description" />
          </FormGroup>
          <div className="tw-flex my-4">
            {item.id ? (
              <ImpersonateButton email={item.email} className="mr-auto" />
            ) : null}
            <BackButton className="mr-2"  onClick={onBack}/>
            <SaveButton form={form} hidden={readOnly} onClick={() => {HandlePost(item)}} />
          </div>
          <div className="my-4"> 
          <PermissionTable
            permissionOptions={permissionOptions}
            onPermissionChange={setPermissions}
            parentPermissions={permissions || []}
          />


        </div>
          <div className="my-4">--Below fields are for development only---</div>
        <FormGroup label="Permission Assigned"model=".permissions">
            <Control.text model=".permissions" />
          </FormGroup>
          <FormGroup label="Group Role"model=".id">
            <Control.text model=".id" />
          </FormGroup>
        </LocalForm>
      </Page>
    );
  };

  const enhance = compose(
    withReload(),
    withServerErrors(),
    withStateHandlers(
      {},
      {
        setGlobalSettings: () => (globalSettings) => ({ globalSettings }),
        setStats: () => (stats) => ({ stats }),
      }
    ),
    withResolver(
      {
        globalSettings: () => (client) => client.get("global_settings"),
        stats:
          ({ match }) =>
            (client) =>
              client
                .get(`authorization/group/${match.params.id}`)
                .get("data")
                .catch((err) => {
                  return [];
                })
                .then((i) => ({
                  data: orderBy(
                    i,
                    ["", ""],
                    ["desc", "asc"]
                  ),
                })),
      },
      {
        onResolved:
          ({ setGlobalSettings, setStats }) =>
            ({ globalSettings, stats }) =>
              void (setGlobalSettings(globalSettings), setStats(stats)),
      }
    ),
    EditPageGroups({
      url: "authorization/group",
      defaultItem: () => ({

      }),
    }),

    withState("serverErrors", "setServerErrors", {})
  );

  export default enhance(GroupEdit);
